export default "__VITE_ASSET__CdDDtNXi__"